// extracted by mini-css-extract-plugin
module.exports = {"title":"PromptText_title__MqC0C","message":"PromptText_message__1-UEf"};